import { schema } from 'normalizr';

const surveyChoiceSchema = new schema.Entity('choices', {}, {
  idAttribute: 'answerKey'
});

export default surveyChoiceSchema;
